"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssueTrackerService = void 0;
const operators_1 = require("rxjs/operators");
const restservice_1 = require("../../shared/services/restservice");
const http_1 = require("@angular/common/http");
class IssueTrackerService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        this.issuerTrackerurl = '/rest-api/account/tickets/v1/details';
        this.updateTicketURL = '/rest-api/account/tickets/v1/details/update';
        this.preferencesTicketURL = '/rest-api/account/tickets/v1/details/preferences/update';
        this.ticketPreferencesURL = '/rest-api/account/tickets/v1/details/preferences?lobType=';
        // CIP-413
        this.createSupportTicketUrl = '/rest-services/web-wirelessaccount-services/v1/tickets/support-ticket';
    }
    getTicketIssueDetails(ticketId) {
        if (ticketId !== undefined && ticketId !== null) {
            return this.get(this.issuerTrackerurl + '/' + ticketId).pipe(operators_1.map((data) => data));
        }
    }
    getTicketIssueDetailsList(lobType) {
        const inputArgs = new http_1.HttpParams().set('lobType', lobType);
        return this.post(this.issuerTrackerurl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    getPreferences(lobType) {
        return this.get(this.ticketPreferencesURL + lobType).pipe(operators_1.map((data) => data));
    }
    updateTicket(content) {
        return this.post(this.updateTicketURL, content, true).pipe(operators_1.map((data) => data));
    }
    updatePreferences(content) {
        return this.post(this.preferencesTicketURL, content, true).pipe(operators_1.map((data) => data));
    }
    createSupportTicket(apiRequest) {
        return this.post(this.createSupportTicketUrl, apiRequest, true).pipe(operators_1.map((data) => data));
    }
}
exports.IssueTrackerService = IssueTrackerService;
//# sourceMappingURL=issuetracker.service.js.map